import { orderBy, State } from "@progress/kendo-data-query";

// eslint-disable-next-line no-extend-native
Array.prototype.orderBy = function (dataState: State) {
  return orderBy(this, dataState.sort ?? []);
};

export {};
